import { createSelector } from '@reduxjs/toolkit';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export const basketReducer = state => state.basket;
export const basketSelector = state => state.basket.basket;

export const errorSelector = state => state.basket.errors;
export const pendingSelector = state => state.basket.pending;

export const listSelectorCreator = createSelectorCreator(
  defaultMemoize,
  (prev, current) => {
    return prev.basket.basketitem_set === current.basket.basketitem_set
  }
)

export const errorSelectorCreator = createSelectorCreator(
  defaultMemoize,
  (prev, current) => {
    return prev.errors === current.errors
  }
)

export const basketItemListSelector = createSelector(
  basketSelector,
  basket => basket.basketitem_set
)

export const basketItemSelector = basketItemId => createSelector(
  basketItemListSelector,
  basketItemList => basketItemList.find(item => item.id == basketItemId)
)

export const giftNoteSelector = basketItemId => createSelector(
  basketItemSelector(basketItemId),
  basketItem => basketItem?.attributes?.gift_note
)

export const quantitySelector = createSelector(
  basketSelector,
  basket => basket.quantity_selector
)

export const discountsSelector = createSelector(
  basketSelector,
  basket => basket.discounts
)

export const basketListSelector = listSelectorCreator(
  basketReducer,
  state => {
    return ({
      list: state.basket.basketitem_set,
      errors: state.errors,
      pending: state.pending,
    })
  }
)

export const basketErrorSelector = errorSelectorCreator(
  basketReducer,
   state => {
    return ({
      errors: state.errors,
      pending: state.pending,
    })
  }
)

export const basketPendingSelector = createSelector(
  pendingSelector,
  pending => pending
)
